import Vue from 'vue'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
import router from './router/index-furnishweb.js'
import store from './store/furnishweb.js' 
import "./validation-rules/rules";
import CoolLightBox from 'vue-cool-lightbox'
Vue.use(CoolLightBox)
console.log("store",store)
import App from './AppFurnishWeb.vue'
const isDev = process.env.NODE_ENV
console.log("isDev",isDev)
import Cart from './furnishweb/components/vue-material-design-icons/Cart';
import ArrowRight from './furnishweb/components/vue-material-design-icons/ArrowRight.vue';
import QrcodeScan from './furnishweb/components/vue-material-design-icons/QrcodeScan';
import SearchWeb from './furnishweb/components/vue-material-design-icons/SearchWeb';
import MobileFilter from './furnishweb/components/vue-material-design-icons/MobileFilter';
import CloseCircleOutline from './furnishweb/components/vue-material-design-icons/CloseCircleOutline';
Vue.component('close-icon', CloseCircleOutline);
Vue.component('qrcode-scan', QrcodeScan);
Vue.component('search-web', SearchWeb);
Vue.component('filter-menu', MobileFilter);
Vue.component('cart-icon', Cart);
Vue.component('arrow-right', ArrowRight);
Vue.prototype.$eventBus = new Vue();
import { Loading } from 'element-ui'
Vue.use(Loading.directive)
import ThatsNotify from './util/Notify.js'
Vue.use(ThatsNotify)
import 'sweetalert2/src/sweetalert2.scss'
import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);
const x = new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App),
})
console.log(x)